import { useState } from 'react';
import { Box, CssBaseline, Typography, Stack, Button, TextField, MenuItem, IconButton, Popover } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import logoImage from '../static/caledoniaLogo.png'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';


const eventID = "6a0d871751beac0014246bc6";

const webcastUrl = `https://stream.brrmedia.co.uk/broadcast/${eventID}`;
const backgroundVideo = 'https://brrmedia-clients-uploads.s3.us-west-2.amazonaws.com/caledonian-mining/videos/caledoniaBg.mp4';

const typeOptions = ['Investor', 'Analyst', 'Other'];

const countryCodes = [
  'AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM',
  'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ',
  'BM', 'BT', 'BO', 'BQ', 'BA', 'BW', 'BV', 'BR', 'IO', 'BN', 'BG', 'BF',
  'BI', 'CV', 'KH', 'CM', 'CA', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC',
  'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'HR', 'CU', 'CW', 'CY', 'CZ',
  'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET',
  'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE',
  'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY',
  'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE',
  'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR',
  'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO',
  'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX',
  'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP',
  'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'MK', 'MP', 'NO', 'OM',
  'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR',
  'QA', 'RE', 'RO', 'RU', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC',
  'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI',
  'SB', 'SO', 'ZA', 'GS', 'SS', 'ES', 'LK', 'SD', 'SR', 'SJ', 'SE', 'CH',
  'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR',
  'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'GB', 'US', 'UM', 'UY', 'UZ', 'VU',
  'VE', 'VN', 'VG', 'VI', 'WF', 'EH', 'YE', 'ZM', 'ZW'
];

const countryDisplayNames = typeof Intl !== 'undefined' && Intl.DisplayNames
  ? new Intl.DisplayNames(['en'], { type: 'region' })
  : null;

const countryOptions = countryCodes
  .map((code) => countryDisplayNames ? countryDisplayNames.of(code) : code)
  .filter(Boolean)
  .sort((a, b) => a.localeCompare(b));

export default function HomePage() {

  const [showButtons, setShowButtons] = useState(true);
  const [showForm, setShowForm] = useState(false)
  const [formData, setFormData] = useState({ name: '', email: '', company: '', country: '', type: '' });

  const [submitted, setSubmitted] = useState(false)
  const [attending, setAttending] = useState('inperson')
  const [privacyAnchorEl, setPrivacyAnchorEl] = useState(null)

  const isPrivacyPopoverOpen = Boolean(privacyAnchorEl);

  const registerOnlineRegistrant = async () => {
    const onlineRegistrantPayload = {
      eventid: eventID,
      fields: {
        name: formData.name,
        company: formData.company,
        email: formData.email,
        country: formData.country,
        type: formData.type,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/registrant/createnew/?token=${process.env.REACT_APP_API_BASE_TOKEN}`,
      onlineRegistrantPayload
    );

    if (!response.data.success) {
      throw new Error(response.data.message || response.data.error || 'Unable to register online attendee');
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    // Add your form submission logic here
    console.log('Form submitted with data:', formData);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/registrant/add/inPersonRegistrant/?token=${process.env.REACT_APP_API_BASE_TOKEN}`, { attending: attending, eventID: eventID, ...formData });
      console.log('Response from server:', response.data);
      if (response.data.success) {
        if (attending === 'virtual') {
          await registerOnlineRegistrant();
        }

        setShowForm(false)
        setSubmitted(true)
        // attending === 'inperson' ? setSubmitted(true) : setSubmittedVirtual(true)

      }


      if (!response.data.success) {
        // setShowForm(false)
        // setSubmitted(true)
        toast.error("User already exist")

      }

    } catch (error) {
      // Handle errors
      toast.error("Something went wrong")
      console.error('Error submitting form:', error);
    }

  };

  const handleInputChange = async (event) => {

    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePrivacyPopoverOpen = (event) => {
    setPrivacyAnchorEl(event.currentTarget);
  };

  const handlePrivacyPopoverClose = () => {
    setPrivacyAnchorEl(null);
  };

  const handleOnBack = () => {
    setShowButtons(true)
    setShowForm(false)
    setSubmitted(false)
  }

  const handleInperson = () => {
    setAttending('inperson')
    setSubmitted(false)
    setShowButtons(false);
    setShowForm(true)
  };

  const handleOnline = () => {
    setAttending('virtual')
    setSubmitted(false)
    setShowButtons(false);
    setShowForm(true)
  }

  const HandleUnabletoAttend = () => {
    setAttending('unabletoattend')
    setSubmitted(false)
    setShowForm(true)
    // setUnableToAttend(true)
    setShowButtons(false)
  }

  return (
    <Box
      //   component="main"
      sx={{
        position: 'relative',
        isolation: 'isolate',
        overflow: 'hidden',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        height: 'auto',
        minHeight: '100vh',
        display: 'flex',
        padding: '20px 0 20px 0',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        component="video"
        src={backgroundVideo}
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      />
      <Toaster />
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.87)', // Adjust the opacity as needed
          borderRadius: '8px',
          maxWidth: '490px',
          width: '70%',
          height: 'auto',
          maxHeight: 'auto',
          textAlign: 'center',
        }}
      >
        <Box sx={{ background: '', display: 'flex', justifyContent: 'center', alignSelf: 'center', alignItems: 'center', p: 3 }}>
          <img src={logoImage} alt="Logo" style={{ maxWidth: '100%', height: '65px', mixBlendMode: 'multiply' }} />

        </Box>

        <Typography sx={{ fontSize: '1.1rem' }}>
          CMD 2026
        </Typography>

        <Typography sx={{ fontSize: '1.1rem' }}>
          New York
        </Typography>

        {<Typography sx={{ fontSize: '1.1rem' }}>
          Wednesday, September 16, 2026
        </Typography>}

        <Stack sx={{ p: 3 }}>
          {
            showButtons && <>
              <Typography
                sx={{
                  fontSize: '1.20rem',
                  fontWeight: '200%',
                  '@media (max-width:600px)': {
                    fontSize: '1.1rem', // Adjust the font size for smaller screens
                  },
                }}
              >                    Are you able to attend?
              </Typography>
              <Button onClick={handleInperson} sx={{
                background: '#123a49', color: 'white', p: 1.5, m: 1.5, borderRadius: '15px', '&:hover': {
                  background: '#668491', cursor: 'pointer'
                }
              }}>
                In Person
              </Button>


              <Button onClick={handleOnline} sx={{
                background: '#123a49', color: 'white', p: 1.5, m: 1.5, borderRadius: '15px', '&:hover': {
                  background: '#668491',
                }
              }}>               Online
              </Button>


              <Button onClick={HandleUnabletoAttend} sx={{
                background: '#123a49', color: 'white', p: 1.5, m: 1.5, borderRadius: '15px', '&:hover': {
                  background: '#668491',
                }
              }}>               Unable to attend
              </Button>
            </>
          }

          {
            showForm &&
            <form onSubmit={handleFormSubmit}>
              <TextField
                label="Name"
                variant="outlined"
                fullWidth
                margin="normal"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                margin="normal"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <TextField
                label="Company"
                variant="outlined"
                fullWidth
                margin="normal"
                name="company"
                value={formData.company}
                onChange={handleInputChange}
                required
              />
              <TextField
                select
                label="Country"
                variant="outlined"
                fullWidth
                margin="normal"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                required
              >
                {countryOptions.map((country) => (
                  <MenuItem key={country} value={country}>
                    {country}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="Type"
                variant="outlined"
                fullWidth
                margin="normal"
                name="type"
                value={formData.type}
                onChange={handleInputChange}
                required
              >
                {typeOptions.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 1 }}>
                <Typography sx={{ fontSize: '0.9rem' }}>
                  Your details are used to manage your registration, share relevant event updates, and handle your data in line with our <a href={"https://wp-caledoniamining-2020.s3.eu-west-2.amazonaws.com/media/2019/03/Caledonia-Group-Privacy-Policy-2026.pdf"} target="_blank" rel="noopener noreferrer">Privacy Notice</a>.
                </Typography>
                <IconButton
                  aria-describedby={isPrivacyPopoverOpen ? 'privacy-notice-popover' : undefined}
                  aria-label="View privacy notice"
                  onClick={handlePrivacyPopoverOpen}
                  size="small"
                  sx={{ color: '#123a49' }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Box>
              <Popover
                id="privacy-notice-popover"
                open={isPrivacyPopoverOpen}
                anchorEl={privacyAnchorEl}
                onClose={handlePrivacyPopoverClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <Typography sx={{ fontSize: '0.9rem', maxWidth: 360, p: 2 }}>
                  (*) For registering to Caledonia Mining CMD 26, we collect your name, company, email address, country and type to manage your participation. The event will be recorded and published on our corporate website. We retain your contact details after the event to send updates about future events and capital markets communications. You can opt out at any time by sending e-mail to: <a href="mailto:dataprotection@caledoniamining.com" target="_self" rel="noopener noreferrer">dataprotection@caledoniamining.com</a>. For more details on how we handle your data, your rights and our contact information, please see our full <a href={"https://wp-caledoniamining-2020.s3.eu-west-2.amazonaws.com/media/2019/03/Caledonia-Group-Privacy-Policy-2026.pdf"} target="_blank" rel="noopener noreferrer">Privacy Notice</a>.
                </Typography>
              </Popover>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleOnBack} sx={{ fontSize: '1rem', background: '#123a49', color: 'white', p: 1, m: 2, '&:hover': { background: '#668491' } }}>
                  Back
                </Button>

                <Button type="submit" sx={{ fontSize: '1rem', background: '#123a49', color: 'white', p: 1, m: 2, '&:hover': { background: '#668491' } }}>
                  Submit
                </Button>

              </Box>
            </form>
          }

          {
            submitted && (
              attending === 'inperson' ? (
                <Typography sx={{ fontSize: '1.1rem' }}>
                  Thank you for your interest in attending the event in person. PPC’s Investor Relations team will follow up with you shortly regarding your participation.
                </Typography>
              ) : attending === 'virtual' ? (
                <>
                  <Typography sx={{ fontSize: '1.1rem' }}>
                    Thank you for confirming your interest in attending the event via live webcast.
                  </Typography>
                  <Button
                    component="a"
                    href={webcastUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ background: '#123a49', color: 'white', p: 1.5, m: 1.5, borderRadius: '15px', '&:hover': { background: '#668491' } }}
                  >
                    Access webcast
                  </Button>
                </>
              ) : attending === 'unabletoattend' ? (
                <Typography sx={{ fontSize: '1.1rem' }}>
                  Thank you for confirming that you are unable to attend the event. PPC’s IR team has noted your response accordingly.
                </Typography>
              ) : null
            )
          }
        </Stack>
      </Box>
    </Box>
  )
}
